export const formatearPesos = (e) => {
    let priceText = e;
    const isNegative = priceText.indexOf("-") === 0;

    return Number(priceText.substr(Number(isNegative)).replace(/\D/g, ""));
}

export const formatearValor = (value) => Number(value).toLocaleString('es-CO');